// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { TransformId } from "./transform-id";

export class TransformRule implements flatbuffers.IUnpackableObject<TransformRuleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TransformRule {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTransformRule(bb: flatbuffers.ByteBuffer, obj?: TransformRule): TransformRule {
    return (obj || new TransformRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTransformRule(
    bb: flatbuffers.ByteBuffer,
    obj?: TransformRule,
  ): TransformRule {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TransformRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(): TransformId {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : TransformId.Unspecified;
  }

  outputs(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
  }

  outputsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  outputsArray(): Uint32Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? new Uint32Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  params(index: number): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt64(this.bb!.__vector(this.bb_pos + offset) + index * 8) : 0n;
  }

  paramsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startTransformRule(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addId(builder: flatbuffers.Builder, id: TransformId) {
    builder.addFieldInt16(0, id, TransformId.Unspecified);
  }

  static addOutputs(builder: flatbuffers.Builder, outputsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, outputsOffset, 0);
  }

  static createOutputsVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint32Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createOutputsVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createOutputsVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint32Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt32(data[i]!);
    }
    return builder.endVector();
  }

  static startOutputsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addParams(builder: flatbuffers.Builder, paramsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, paramsOffset, 0);
  }

  static createParamsVector(builder: flatbuffers.Builder, data: bigint[]): flatbuffers.Offset {
    builder.startVector(8, data.length, 8);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt64(data[i]!);
    }
    return builder.endVector();
  }

  static startParamsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 8);
  }

  static endTransformRule(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createTransformRule(
    builder: flatbuffers.Builder,
    id: TransformId,
    outputsOffset: flatbuffers.Offset,
    paramsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    TransformRule.startTransformRule(builder);
    TransformRule.addId(builder, id);
    TransformRule.addOutputs(builder, outputsOffset);
    TransformRule.addParams(builder, paramsOffset);
    return TransformRule.endTransformRule(builder);
  }

  unpack(): TransformRuleT {
    return new TransformRuleT(
      this.id(),
      this.bb!.createScalarList<number>(this.outputs.bind(this), this.outputsLength()),
      this.bb!.createScalarList<bigint>(this.params.bind(this), this.paramsLength()),
    );
  }

  unpackTo(_o: TransformRuleT): void {
    _o.id = this.id();
    _o.outputs = this.bb!.createScalarList<number>(this.outputs.bind(this), this.outputsLength());
    _o.params = this.bb!.createScalarList<bigint>(this.params.bind(this), this.paramsLength());
  }

  unpackFields(...fields: string[]): TransformRuleT {
    const t = new TransformRuleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id();
    }
    if (fieldSet.has("outputs")) {
      t.outputs = this.bb!.createScalarList<number>(this.outputs.bind(this), this.outputsLength());
    }
    if (fieldSet.has("params")) {
      t.params = this.bb!.createScalarList<bigint>(this.params.bind(this), this.paramsLength());
    }
    return t;
  }
}

export class TransformRuleT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: TransformId = TransformId.Unspecified,
    public outputs: number[] = [],
    public params: bigint[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const outputs = TransformRule.createOutputsVector(builder, this.outputs);
    const params = TransformRule.createParamsVector(builder, this.params);

    return TransformRule.createTransformRule(builder, this.id, outputs, params);
  }

  clone(): TransformRuleT {
    const obj = new TransformRuleT();
    obj.id = this.id;
    obj.outputs = [...this.outputs];
    obj.params = [...this.params];
    return obj;
  }

  equals(other: TransformRuleT): boolean {
    if (this.id !== other.id) return false;
    if (this.outputs.length !== other.outputs.length) return false;
    for (let i = 0; i < this.outputs.length; i++) {
      if (this.outputs[i] !== other.outputs[i]) return false;
    }
    if (this.params.length !== other.params.length) return false;
    for (let i = 0; i < this.params.length; i++) {
      if (this.params[i] !== other.params[i]) return false;
    }
    return true;
  }
}

export function verifyTransformRule(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVector(pos, 4);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVector(pos, 8);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
